<template>
  <div id="app">
    <Header></Header>
    <router-view />
  </div>
</template>
<script>
import Header from './components/header/index.vue'
export default {
  components: {Header},
  data() {},
};
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
  background: #f2f4f7;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#btn_next {
  width: 120px;
}
.el-button--primary {
  background: #0570ff !important;
}
.el-radio-button__orig-radio:checked+.el-radio-button__inner {
  background: #0570ff !important;

}
.el-radio__input.is-checked .el-radio__inner{
  background: #0570ff !important;
}

</style>
